module.exports = __webpack_public_path__ + "static/assets/25a47de2144b27834d6b30479590ef03.svg";